import { Button, Flex } from "antd";
import SearchInitiatorFilter from "components/AISeearchMain/SearchInitiatorFilters";
import { useAppSelector } from "hooks/reduxHooks";
import { SvgIcons } from "Icon/SvgIcons";
import React from "react";
import { useSearchParams } from "react-router-dom";

const FilterModalHeader = ({ setIsSearchLoading, showDrawer, runFrom, isModal }: any) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isNamedSearch = useAppSelector((state) => state.search.isNamedSearch);

  const searchId: any = searchParams.get("searchId");
  return (
    <Flex justify="space-between" gap={16} className="p-6 pb-5 bg-bg-primary rounded-t-xl">
      <Flex gap={16}>
        {!isNamedSearch && (
          <span onClick={showDrawer} className="cursor-pointer">
            {SvgIcons.featuredIcon}
          </span>
        )}
        <Flex vertical className="items-center">
          <span className="text-lg font-semibold capitalize text-center">
            {isNamedSearch
              ? "Search By Name"
              : "Define your ideal candidate profile"}{" "}
          </span>
        </Flex>
      </Flex>
      <Flex className="pr-10">
        <SearchInitiatorFilter
          setIsSearchLoading={setIsSearchLoading}
          runFrom={runFrom}
          isModal={isModal}
        />
      </Flex>
    </Flex>
  );
};

export default FilterModalHeader;
